(ns renolit-roofing-service.layout.form.form-item
  (:require [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.util :as util]))

(def ^:const tooltip-group
  "form-item-tooltips")

(defn set-value-in-state
  [state path new-value]
  (let [path-idx (last path)]
    (if-not (int? path-idx)
      (swap! state assoc-in path new-value)
      (swap! state
             update-in
             (vec (butlast path))
             #(-> (vec (concat % (repeat (- (inc path-idx) (count %)) nil)))
                  (assoc path-idx new-value))))))

(defn on-change-event-handler
  [{:keys [state path] :as opts} event-kw new-value]
  (let [{:keys [prevent-default?] :as callback} (get opts event-kw)]
    (when (and (not prevent-default?)
               state)
      (set-value-in-state state path new-value))
    (util/execute-callback callback new-value)))

(defn info-tooltip-reference
  [_props _args _opts]
  [layout.icon/icon
   {:key :info}])

(defn info-tooltip-floating
  [props arrow {:keys [transl-kw]} _opts]
  [:div.form-item__info-tooltip
   props arrow
   (t [transl-kw])])

(defmulti form-item-component :type)
